import React from 'react'

export const TemplateCancellationContext = React.createContext({})

export const TemplateDeclarationConsumer = TemplateCancellationContext.Consumer
